export default "__VITE_ASSET__Cmmtb7pJ__"